export class IndividualTable {
    constructor(container) {
        // dodelat
        this.container = container;
        this.inputName = this.container.dataset.inputName;
        this.onChange = null;
        this.addEventListeners();
    }

    addEventListeners() {
        let selectAllBtn = this.container.querySelector(".button.select-all");
        let deselectAllBtn = this.container.querySelector(".button.deselect-all");
        let selectTopBtn = this.container.querySelector(".button.select-top");
        let selectBottomBtn = this.container.querySelector(".button.select-bottom");
        selectAllBtn.addEventListener('click', () => {
            this.container.querySelectorAll(`input[name=${this.inputName}]`).forEach(el => el.checked = true);
            if (this.onChange) {
                this.onChange();
            }
        });
        deselectAllBtn.addEventListener('click', () => {
            this.container.querySelectorAll(`input[name=${this.inputName}]`).forEach(el => el.checked = false);
            if (this.onChange) {
                this.onChange();
            }
        });
        selectTopBtn.addEventListener('click', () => {
            const num = this.container.querySelector('input.select-num').value;
            this.container.querySelectorAll(`input[name=${this.inputName}]`).forEach((el, i) => el.checked = i < num);
            if (this.onChange) {
                this.onChange();
            }
        });
        selectBottomBtn.addEventListener('click', () => {
            const num = this.container.querySelector('input.select-num').value;
            this.container.querySelectorAll(`input[name=${this.inputName}]`).forEach((el, i) => {
                el.checked = i >= this.container.querySelectorAll(`input[name=${this.inputName}]`).length - num;
            });
            if (this.onChange) {
                this.onChange();
            }
        });
        this.container.querySelectorAll(`input[type='checkbox']`).forEach(el => {
            el.addEventListener('change', () => {
                if (this.onChange) {
                    this.onChange();
                }
            });
        });
    }

    setInputName(name) {
        this.container.querySelectorAll(`input[name=${this.inputName}]`).forEach(el => el.name = name);
        this.inputName = name;
        this.container.dataset.inputName = name;
    }
}